import { QuotePriceField } from '@ui/config/price/constants';
import { WritableQuoteBuilderStateType } from '@ui/features/quote-builder/types/state';
import { QuotePriceType } from '@ui/features/quote-builder/types/state/quote-price';

import { clearRawFieldValues } from '../../utilities/raw-field-values';
import { reconcileQuotePriceFieldIssues } from './reconcile-quote-price-field-issues';

type ReconciledField =
  | 'quantity'
  | 'unitPrice'
  | 'unitCost'
  | 'grossMargin'
  | 'contributionMargin'
  | 'baseGrossMargin';

type ApplyQuotePriceRecalcResultInput = {
  quoteLineUuid: string;
  quotePriceUuid: string;
  quotePrice: QuotePriceType;
  patch: Partial<QuotePriceType>;
  rawFieldsToClear?: QuotePriceField[];
};

const reconciledFields: ReconciledField[] = [
  'quantity',
  'unitPrice',
  'unitCost',
  'grossMargin',
  'contributionMargin',
  'baseGrossMargin',
];

export function applyQuotePriceRecalcResult(
  state: WritableQuoteBuilderStateType,
  params: ApplyQuotePriceRecalcResultInput,
) {
  const {
    quoteLineUuid,
    quotePriceUuid,
    quotePrice,
    patch,
    rawFieldsToClear = [],
  } = params;

  Object.assign(quotePrice, patch);

  if (rawFieldsToClear.length > 0) {
    clearRawFieldValues(
      state,
      rawFieldsToClear.map((field) => ({
        uuid: quotePriceUuid,
        field,
      })),
    );
  }

  const reconcileParams: {
    quoteLineUuid: string;
    quotePriceUuid: string;
    quantity?: QuotePriceType['quantity'] | null;
    unitPrice?: QuotePriceType['unitPrice'] | null;
    unitCost?: QuotePriceType['unitCost'] | null;
    grossMargin?: QuotePriceType['grossMargin'] | null;
    contributionMargin?: QuotePriceType['contributionMargin'] | null;
    baseGrossMargin?: QuotePriceType['baseGrossMargin'] | null;
  } = {
    quoteLineUuid,
    quotePriceUuid,
  };

  for (const field of reconciledFields) {
    if (Object.prototype.hasOwnProperty.call(patch, field)) {
      reconcileParams[field] = quotePrice[field];
    }
  }

  reconcileQuotePriceFieldIssues(state, reconcileParams);
}
